import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery } from "../../../services/process/BRS1/brsService7";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Icon, Modal } from 'semantic-ui-react';

function TrialBalanceExecution() {
  const [finyr, setFinyr] = useState([]);
  const [selectedFinyr, setSelectedFinyr] = useState(null);
  const [selectedQuarter, setSelectedQuarter] = useState(null);
  const [monthOptions, setMonthOptions] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [fetchedData, setFetchedData] = useState([]);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [popupData, setPopupData] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const gridRef = useRef();

  const [relationshipType] = useState([
    { label: 'Group - Entity', value: '1', value1: 'groups', value2: 'entities' },
    { label: 'Entity - Division', value: '2', value1: 'entities', value2: 'divisions' },
    { label: 'Division - Department', value: '3', value1: 'divisions', value2: 'departments' },
  ]);

  const [selectedRelationshipType, setSelectedRelationshipType] = useState(null);
  const [relationParent, setRelationParent] = useState("");
  const [relationChild, setRelationChild] = useState("");
  const [parentOptions, setParentOptions] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const [childOptions, setChildOptions] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);

  const quarterOptions = [
    { label: "Quarter 1", value: "Q1" },
    { label: "Quarter 2", value: "Q2" },
    { label: "Quarter 3", value: "Q3" },
    { label: "Quarter 4", value: "Q4" },
  ];

const popupColumnDefs = popupData && popupData.length > 0
  ? Object.keys(popupData[0]).map((key) => ({
      headerName: key,
      field: key,
      sortable: true,
      filter: true,
      resizable: true
    }))
  : [];

const columnDefs = fetchedData && fetchedData.length > 0
  ? [
      ...Object.keys(fetchedData[0]).map((key) => ({
        headerName: key,
        field: key,
        sortable: true,
        filter: true,
        resizable: true
      })),
      {
        headerName: "Action",
        field: "action",
        cellRendererFramework: (params) => (
          <Icon
            name="eye"
            style={{ cursor: 'pointer' }}
            onClick={() => openPopupForRow(params.data["primary_id"])}
          />
        )
      }
    ]
  : [];




  const quarterToMonthsMap = {
    Q1: [
      { label: "April", value: "4" },
      { label: "May", value: "5" },
      { label: "June", value: "6" },
    ],
    Q2: [
      { label: "July", value: "7" },
      { label: "August", value: "8" },
      { label: "September", value: "9" },
    ],
    Q3: [
      { label: "October", value: "10" },
      { label: "November", value: "11" },
      { label: "December", value: "12" },
    ],
    Q4: [
      { label: "January", value: "1" },
      { label: "February", value: "2" },
      { label: "March", value: "3" },
    ],
  };

  const generateFinancialYearOptions = (startYear, numYears) => {
    const optionsyr = [];
    for (let i = 0; i < numYears; i++) {
      const year1 = startYear + i;
      const year2 = year1 + 1;
      const financialYear = `${year1}-${year2}`;
      optionsyr.push({ key: financialYear, value: financialYear, label: financialYear });
    }
    return optionsyr;
  };

  useEffect(() => {
    const startYear = 2022;
    const numYears = 20;
    const financialYearOptions = generateFinancialYearOptions(startYear, numYears);
    setFinyr(financialYearOptions);
  }, []);

  const handleQuarterChange = (selected) => {
    setSelectedQuarter(selected);
    setSelectedMonth(null);
    if (selected?.value) {
      setMonthOptions(quarterToMonthsMap[selected.value]);
    } else {
      setMonthOptions([]);
    }
  };

  const fetchtabledetailsInfo = async (query, setField, status = "yes") => {
    const payload = { query };
    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;

      if (data && data.length > 0) {
        if (status === "no") {
          setField(data);
        } else {
          const keys = Object.keys(data[0]);
          const labelKey = keys.find((k) => k.toLowerCase().includes("name"));
          const valueKey = keys.find((k) => k.toLowerCase().includes("_id"));

          const formatted = data.map((item) => ({
            label: item[labelKey],
            value: item[valueKey],
            description: item.description || "-",
            ...item
          }));
          setField(formatted);
        }
      } else {
        setField([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setField([]);
    }
  };

  const handleRelationshipTypeChange = async (selected) => {
    const parent = selected.value1;
    const child = selected.value2;
    setSelectedRelationshipType(selected);
    setRelationParent(parent);
    setRelationChild(child);
    setSelectedParent(null);
    setSelectedChild(null);

    const parentQuery = `SELECT name, ${parent === "entities" ? "entity_id" : parent + "_id"} FROM user_management_uat.${parent} WHERE is_active=1`;
    const childQuery = `SELECT name, ${child === "entities" ? "entity_id" : child + "_id"} FROM user_management_uat.${child} WHERE is_active=1`;

    await fetchtabledetailsInfo(parentQuery, setParentOptions);
    await fetchtabledetailsInfo(childQuery, setChildOptions);
  };

  const handleSearch = async () => {
    if (!selectedFinyr || !selectedQuarter || !selectedMonth || !selectedParent || !selectedChild) {
      alert("Please select all required filters.");
      return;
    }

    setLoaderOpen(true);
    setShowGrid(false);

    const query = `
      SELECT
    g.\`GL Code\` AS group_gl_code,
    g.description AS group_description,
    gm.\`TB code\`,
    gm.\`Financial caption\`,
    gm.\`Schedule classification\`,
    gm.\`Nature of Ledger\`,

    -- Closing Balance: OB + Dr - Cr
    (COALESCE(g.\`Opening_balance\`, 0) + COALESCE(SUM(e.\`Opening_balance\`), 0)) +
    (COALESCE(g.\`Dr.\`, 0) + COALESCE(SUM(e.\`Dr.\`), 0)) -
    (COALESCE(g.\`Cr.\`, 0) + COALESCE(SUM(e.\`Cr.\`), 0)) AS closing_balance,
    COALESCE(g.\`Dr.\`, 0) + COALESCE(SUM(e.\`Dr.\`), 0) AS debit,
    COALESCE(g.\`Cr.\`, 0) + COALESCE(SUM(e.\`Cr.\`), 0) AS credit,


    -- Combined totals: group + entity
    COALESCE(g.\`Opening_balance\`, 0) + COALESCE(SUM(e.\`Opening_balance\`), 0) AS opening_balance,g.primary_id


FROM
    gltest.group_tb_details AS g

LEFT JOIN
    gltest.group_tb_master AS gm
    ON g.\`GL Code\` = gm.\`GL Code\`

LEFT JOIN
    gltest.entity_tb_master AS tm
    ON tm.\`group_map_id\` = gm.\`primary_id\`

LEFT JOIN
    gltest.entity_tb_details AS e
    ON e.\`GL Code\` = tm.\`GL Code\`

GROUP BY
    g.\`GL Code\`,
    g.description,
    gm.\`TB code\`,
    gm.\`Financial caption\`,
    gm.\`Schedule classification\`,
    gm.\`Nature of Ledger\`,
    g.\`Opening_balance\`,
    g.\`Dr.\`,
    g.\`Cr.\`;

    `;

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], { query }, FileUploadCredentials[0]);
      setFetchedData(response.data);
      setShowGrid(true);
    } catch (err) {
      console.error(err);
      setFetchedData([]);
    } finally {
      setLoaderOpen(false);
    }
  };

  const openPopupForRow = async (tbCode) => {
    const query = `
      SELECT 
        e.\`GL Code\`, e.\`Dr.\` as debit, e.\`Cr.\` as credit, e.\`opening_balance\`
      FROM 
        gltest.entity_tb_details AS e
      LEFT JOIN 
        gltest.entity_tb_master AS tm ON e.\`GL Code\` = tm.\`GL Code\`
      LEFT JOIN 
        gltest.group_tb_master AS gm ON gm.\`primary_id\` = tm.\`TB code\`
      WHERE tm.\`group_map_id\` = '${tbCode}'
    `;
    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], { query }, FileUploadCredentials[0]);
      setPopupData(response.data);
      setPopupOpen(true);
    } catch (err) {
      console.error(err);
      setPopupData([]);
    }
  };


  return (
    <div style={{ padding: 20 }}>
      {loaderOpen && <LoaderComponent open={loaderOpen} />}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, marginBottom: 20 }}>
        <div style={{ width: 200 }}>
          <label>Financial Year</label>
          <Select options={finyr} value={selectedFinyr} onChange={setSelectedFinyr} isSearchable placeholder="Select FY" />
        </div>
        <div style={{ width: 200 }}>
          <label>Quarter</label>
          <Select options={quarterOptions} value={selectedQuarter} onChange={handleQuarterChange} isSearchable placeholder="Select Quarter" />
        </div>
        <div style={{ width: 200 }}>
          <label>Month</label>
          <Select options={monthOptions} value={selectedMonth} onChange={setSelectedMonth} isSearchable isDisabled={!selectedQuarter} placeholder="Select Month" />
        </div>
        <div style={{ width: 200 }}>
          <label>Relationship Type</label>
          <Select options={relationshipType} value={selectedRelationshipType} onChange={handleRelationshipTypeChange} />
        </div>
        <div style={{ width: 200 }}>
          <label>Parent</label>
          <Select options={parentOptions} value={selectedParent} onChange={setSelectedParent} isDisabled={!selectedRelationshipType} />
        </div>
        <div style={{ width: 200 }}>
          <label>Child</label>
          <Select options={childOptions} value={selectedChild} onChange={setSelectedChild} isDisabled={!selectedRelationshipType} />
        </div>
        <button onClick={handleSearch} className="submit-btn" style={{ height: 40, alignSelf: 'end' }}>Search</button>
      </div>

      {showGrid && (
        <div className="ag-theme-alpine" style={{ height: '500px',width:'1500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={fetchedData}
            columnDefs={columnDefs}
            domLayout='autoHeight'
          />
        </div>
      )}

      <Modal
  open={popupOpen}
  onClose={() => setPopupOpen(false)}
  size="small"
  style={{ height: '600px',marginLeft:"500px",marginTop:"100px",width:'1080px' }}
>
  <Modal.Header>Entity Trial Balance Details</Modal.Header>
  <Modal.Content scrolling>
    <div className="ag-theme-alpine" style={{ height: '500px', width: '100%' }}>
      <AgGridReact
        rowData={popupData}
        columnDefs={popupColumnDefs}
        domLayout="autoHeight"
      />
    </div>
  </Modal.Content>
</Modal>
    </div>
  );
}

export default TrialBalanceExecution;
